














import Vue from 'vue';
import { Icon } from 'leaflet';
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { ICoordinates } from '../../../common/interfaces/location.interface';

interface IRinganaMapComponent {
  attribution: string;
  tileUrl: string;
  zoom: number;
}

export default Vue.extend({
  name: `RinganaMap`,
  components: {
    LMap,
    LMarker,
    LTileLayer,
  },
  data(): IRinganaMapComponent {
    return {
      attribution: `&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors`,
      tileUrl: `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
      zoom: 13,
    };
  },
  props: {
    coordinates: {
      required: true,
      type: Object as () => ICoordinates,
    },
    showMarker: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    // https://vue2-leaflet.netlify.app/quickstart/#marker-icons-are-missing
    type TD = Icon.Default & {
      _getIconUrl?: string;
    };

    // eslint-disable-next-line no-underscore-dangle
    delete (Icon.Default.prototype as TD)._getIconUrl;
    /* eslint-disable global-require */
    Icon.Default.mergeOptions({
      iconRetinaUrl: require(`leaflet/dist/images/marker-icon-2x.png`),
      iconUrl: require(`leaflet/dist/images/marker-icon.png`),
      shadowUrl: require(`leaflet/dist/images/marker-shadow.png`),
    });
    /* eslint-enable global-require */
  },
});
